import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  FormGroupDirective,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AlertService } from 'src/app/shared';
import { TagParameters } from '../../../../models/index';
import { SiteService } from '../../../../services/site.service';
@Component({
  selector: 'app-data-tag',
  templateUrl: './data-tag.component.html',
  styleUrls: ['./data-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataTagComponent
  implements OnInit, AfterViewChecked, AfterViewInit
{
  @ViewChild('formDirective') formDirective: FormGroupDirective;
  disableSelect = new UntypedFormControl(false);
  tagTypeControl = new UntypedFormControl('', [Validators.required]);
  tagDescriptionControl = new UntypedFormControl('', [
    Validators.required,
    Validators.maxLength(50)
  ]);
  formdata: UntypedFormGroup;
  // formdata = new FormGroup({
  //   tagTypeCtr: new FormControl('', [Validators.required]),
  //   tagDescCtr: new FormControl('', [Validators.required, Validators.maxLength(50)])
  // });
  tagParameters: TagParameters;
  fromDate: string;
  toDate: string;
  tagData: MatTableDataSource<any>;
  displayedColumns = [
    'dataTagID',
    'tagType',
    'tagDescription',
    'tagValid',
    'taggedBy',
    'modifiedTime'
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    public dialogRef: MatDialogRef<DataTagComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private siteService: SiteService,
    private cdRef: ChangeDetectorRef,
    private alertService: AlertService,
    private fb: UntypedFormBuilder
  ) {
    this.tagParameters = <TagParameters>data.tagParameters;
    this.fromDate = data.fromDate;
    this.toDate = data.toDate;
  }
  ngOnInit() {
    this.formdata = this.fb.group({
      tagTypeCtr: ['', [Validators.required]],
      tagDescCtr: ['', [Validators.required, Validators.maxLength(50)]]
    });
    this.fetchTaggedData();
  }
  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formdata.get(fieldName).hasError(errorCode);
  };
  isFieldInvalid(field: string) {
    return (
      (!this.formdata.get(field).valid && this.formdata.get(field).touched) ||
      this.formdata.get(field).untouched
    );
  }
  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
  public submit = () => {
    this.tagParameters.taggedBy = 'admin'; // Will get from logged in
    this.siteService.saveDataTag(this.tagParameters).subscribe((data: any) => {
      this.tagParameters.message = data.message;
      this.alertService.message = data.message;
      this.alertService.showSuccess(data.message);
      this.formDirective.resetForm();
      this.formdata.reset();
    });
  };
  public onSelectedTab = (event: any) => {
    if (event.index === 1) {
      this.fetchTaggedData();
    } else {
      this.formDirective.resetForm();
      this.formdata.reset();
    }
  };
  private fetchTaggedData = () => {
    this.siteService
      .fetchTaggedData(
        this.tagParameters.siteID,
        this.fromDate,
        this.toDate,
        this.tagParameters
      )
      .subscribe((res) => {
        this.tagData = new MatTableDataSource<any>(res);
        this.tagData.paginator = this.paginator;
      });
  };
  closeDialog() {
    this.dialogRef.close();
  }
}
